import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { OrganizationLoginService } from '../services/organization-login.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationAuthGuard implements CanActivate {
  constructor(private organizationLoginService: OrganizationLoginService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(!this.organizationLoginService.isOrganizationLoggedIn()) {
        this.router.navigate(['login']);
        return false;
      }
      return this.organizationLoginService.isOrganizationLoggedIn(); 
  }
  
}
